export default function formatCreditCardNumber(cardNumber) {
  const cleanNumber = String(cardNumber).replace(/\D/g, '');
  const formattedNumber = cleanNumber.replace(/(\d{4})(?=\d)/g, '$1 ');
  return formattedNumber;
}
flarum.reg.add('ziiven-ziven-core', 'common/helpers/formatCreditCardNumber', formatCreditCardNumber);